/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fuzzy_Busy_Giraffe_SwimInputs */

const fr_fuzzy_busy_giraffe_swim = /** @type {(inputs: Fuzzy_Busy_Giraffe_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jour`)
};

/**

* @param {Fuzzy_Busy_Giraffe_SwimInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fuzzy_busy_giraffe_swim = /** @type {((inputs?: Fuzzy_Busy_Giraffe_SwimInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fuzzy_Busy_Giraffe_SwimInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fuzzy_busy_giraffe_swim(inputs)
});